import React, { FC, useEffect, useState } from "react";

import Button from "ui/Button/Button";

import { getEntityFromWindow } from "helpers/window";

import styles from "./WebchatButton.module.scss";

type Props = {
  onClick?: () => void;
};

const WebchatButton: FC<Props> = ({ onClick }) => {
  const [loading, setLoading] = useState(false);
  const [isWebchat, setIsWebchat] = useState(false);

  useEffect(() => {
    const webchatInit = async () => {
      const webchat = await getEntityFromWindow<Window["webchat"]>("webchat");

      if (webchat) {
        setIsWebchat(true);
      }
    };

    webchatInit();
  }, []);

  const handleChat = async () => {
    setLoading(true);

    const webchat = await getEntityFromWindow<Window["webchat"]>("webchat");
    if (webchat?.open) {
      webchat.open();
      onClick && onClick();
    }

    setLoading(false);
  };

  if (!isWebchat) return null;

  return (
    <Button
      className={styles.btn}
      onClick={handleChat}
      disabled={loading}
      fluid
      orange
    >
      Написать
    </Button>
  );
};

export default WebchatButton;
